<template lang="pug">
  div
    .main
      .row
        .col-md-6.col-lg-5.col-xl-4
          h2.title 营业收费系统-数据总览
</template>

<script>
export default {
  name: 'dashboard-businessCharges'
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Dashboard.vue?001d2588